/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const PlusIcon: React.SFC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
        <circle stroke="#F07662" cx="10" cy="10" r="9.5"/>
        <path d="M11 9V5H9v4H5v2h4v4h2v-4h4V9h-4z" fill="#F07662"/>
        </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Plus/Plus.tsx